































































































import {Component, Watch, Mixins} from 'vue-property-decorator'
import {$, MixinUpload} from 'simpli-web-sdk'
import {UploadConfig} from '@/config/upload.config'
import EmailDestinatario from '@/model/resource/EmailDestinatario'
import Papa from 'papaparse'
import {FileObject} from 'image-compressor.js'
import * as Helper from '@/helpers'
import {AppConfig} from '@/config/app.config'
import PersistEmailDestinatarioRequest from '@/model/request/PersistEmailDestinatarioRequest'

const metaInfo = () => ({
  title: $.t('view.manage.addresseeEmail.title'),
})

@Component({
  metaInfo,
})
export default class ManageRotasSlaView extends Mixins(MixinUpload) {
  readonly UPLOAD_CONFIG = UploadConfig.buildDataPreset(1)

  selectedAddressee: EmailDestinatario | null = null

  list: EmailDestinatario[] = []
  listEmail: string[] | null = null

  get listWithNull() {
    return [new EmailDestinatario(), ...this.list]
  }

  async mounted() {
    await this.populate()
  }

  @Watch('selectedAddressee.cpfCnpj')
  async selectedAddresseeEvent(cpfCnpj: string | null) {
    if (cpfCnpj && this.selectedAddressee) {
      const {data} = await this.selectedAddressee.listEmailsByCpfCnpj()
      this.listEmail = data
    } else {
      this.listEmail = null
    }
  }

  async populate() {
    const {data} = await EmailDestinatario.listCpfCnpjDestinatario()
    this.list = data.map((cpfCnpj) => {
      const model = new EmailDestinatario()
      model.cpfCnpj = cpfCnpj
      return model
    })
  }

  @Watch('files') // upload
  async filesEvent(files: FileObject[]) {
    if (!files.length) return
    $.await.init('uploadCsv')

    const blueprint = AppConfig.csvBlueprint.emails
    const data = await Helper.csvToNormalizedData(files[0].file, blueprint)

    const request = new PersistEmailDestinatarioRequest()
    request.emails = data.map((item) => {
      const model = new EmailDestinatario()
      model.email = item.email
      model.cpfCnpj = item.cpfCnpj
      return model
    })

    try {
      await request.persistEmailDestinatario()
    } finally {
      $.await.done('uploadCsv')
    }

    Helper.success('system.success.persist')

    await this.populate()
    this.selectedAddressee = null
  }

  async downloadCsv() {
    const {data} = await this.$await.run(() => EmailDestinatario.listEmailDestinatario(), 'downloadCsv')
    const list = data.map((item: EmailDestinatario) => ({
      'CPF / CNPJ - DESTINATÁRIO': Helper.cpfOrCnpj(item.cpfCnpj),
      'EMAIL - DESTINATÁRIO': item.email,
    }))
    const csv = Papa.unparse(list)
    Helper.createCsvFile('emails.csv', csv)
  }
}
